<template>
    <section class="table_of_contents" ref="table_elt" @scroll="handleScroll">
        <button class="handler" @click="toggleState"></button>
        <ul class="content">
            <li v-for="(item, idx) in cases" :key=idx v-if="idx > 0">
                <button type="button" @click="goToSlide(idx); close();">
                    <span class="year">{{ item.year }}</span>
                    <span class="title">{{ item.title }} <em v-if="item.sub_title">({{ item.sub_title }})</em></span>
                </button>
            </li>
        </ul>
    </section>
</template>

<script>
export default {
    name: 'TableOfContents',
    props: { cases:{ default:[] } },
    data(){
        return { open:false }
    },
    methods: {
        toggleState(){
            this.$refs.table_elt.classList.toggle('open')
            this.open = !this.open
        },
        close(){
            if(this.open){
                this.$refs.table_elt.classList.remove('open')
                this.open = false
            }
        },
        goToSlide(slideIdx){ this.$root.$emit('goToSlide', { slideIdx:slideIdx }) },
        handleScroll(e){}
    }
}
</script>

<style lang="scss">
    .table_of_contents {
        position:fixed; height:100%; width:40%; top:0; right:-40%; z-index:3; padding:$space; transition:right .5s ease; box-shadow:0 3px 10px rgba(0,0,0,.6); background:$golden; border-left:1px solid darken($golden, 10%);
        &.open { right:0; transition:right .5s ease; }

        .content {
            list-style:none; margin:0; padding:0; font-family:$sans-serif; height:100%; overflow:auto;

            li { margin-bottom:$space; }
        }

        button {
            cursor:pointer;
            &:focus, &:active { outline:none }
        }

        .handler {
            position:absolute; top:15%; left:-48px; transform:translateY(-50%); height:40px; width:48px; background:$golden; border:1px solid darken($golden, 10%); border-right:none; margin-right:-1px;
            &:before, &:after { content:""; position:absolute; top:27px; left:10px; height:0; width:calc(100% - 20px); border-top:3px solid #fff; }
            &:before { top:9px; height:12px; border-bottom:3px solid #fff }
        }
        &.open {
            .handler {
                &:before, &:after { transform-origin:50% }
                &:before { border-top:0; transform:rotate(45deg); left:14px }
                &:after { transform:rotate(-45deg); top:16px }
            }
        }

        button {
            display:flex; flex-flow:row; width:100%; margin-bottom:$space*1.1;
            span {
                display:block;

                &.year { color:#fff; font-family:$gorod; margin-bottom:$space/2; margin-right:$space }
                &.title { font-weight:bold; em { font-weight:normal; font-style:normal } }
            }
        }

        @include small {
            width:88%; right:-88%;

            button span.year { font-size:.8rem!important }
            button span.title { font-size:.8rem!important; text-align:left!important }
        }

        @include medium {
            width:60%; right:-60%;
        }

        ::-webkit-scrollbar { width:5px; height:5px }
        ::-webkit-scrollbar-button { width:0px; height:0px; }
        ::-webkit-scrollbar-thumb { background:rgba(0,0,0,.3); border:0px none #ffffff; border-radius:100px; }
        ::-webkit-scrollbar-thumb:hover { background:rgba(0,0,0,.5); }
        ::-webkit-scrollbar-thumb:active { background:rgba(0,0,0,.5); }
        ::-webkit-scrollbar-track { background:rgba(0,0,0,.1); border:0px none #ffffff; border-radius:20px; }
        ::-webkit-scrollbar-track:hover { background:rgba(0,0,0,.1); }
        ::-webkit-scrollbar-track:active { background:rgba(0,0,0,.1); }
        ::-webkit-scrollbar-corner { background:transparent; }
    }
</style>